import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import { createFeatureSelector } from '@ngrx/store';
import { IMediumState } from './medium.reducer';
import { mediumFeatureKey, MediumModel } from './types';

const mediumFeatureState =
  createFeatureSelector<IMediumState>(mediumFeatureKey);

export const mediumSelectors = {
  getById: createApiCallSelectors<number, IMediumState>(
    mediumFeatureState,
    'getById',
  ),
  getList: createApiCallSelectors<void, IMediumState>(
    mediumFeatureState,
    'getList',
  ),
  add: createApiCallSelectors<MediumModel, IMediumState>(
    mediumFeatureState,
    'add',
  ),
  update: createApiCallSelectors<MediumModel, IMediumState>(
    mediumFeatureState,
    'update',
  ),
};
